import { CircleQuestionIcon } from "assets/icons";
import cn from "classnames";
import { Tooltip } from "react-tooltip";
import { Icon } from "ui";

import { InfoTooltipIconProps } from "./InfoTooltipIcon.types";

import styles from "./InfoTooltipIcon.module.scss";

const InfoTooltipIcon = ({
  id = "info-tooltip-icon",
  tooltipText,
  iconClassName,
  iconSize = 16,
  IconComponent = CircleQuestionIcon
}: InfoTooltipIconProps) => {
  return (
    <>
      <div
        id={id}
        className={cn(styles.infoTooltipIcon, iconClassName)}
        data-tooltip-place="top"
        style={{ cursor: "pointer" }}
      >
        <Icon as={IconComponent} width={iconSize} height={iconSize} />
      </div>

      <Tooltip
        className={styles.infoTooltip}
        anchorSelect={`#${id}`}
        opacity={1}
        offset={5}
        place="top"
      >
        {tooltipText}
      </Tooltip>
    </>
  );
};

export default InfoTooltipIcon;
